import { IExerciseQuestionType } from '../exercises.interface';

/**
 * Returns the solution string for display purposes.
 * Uses solutionString if available, otherwise falls back to solution.
 * Falls solution ein Array ist (z.B. bei FillBlanks), wird es als Satz mit Leerzeichen ausgegeben.
 * For Dialog exercises, shows the correct answer text.
 */
export function getDisplaySolution(question: IExerciseQuestionType): string {
  // Special handling for Dialog exercises
  if (question.type === 'Dialog' && (question as any).getCorrectAnswerText) {
    return (question as any).getCorrectAnswerText();
  }

  if (question.solutionString && typeof question.solutionString === 'string' && question.solutionString.trim() !== '') {
    return question.solutionString;
  }
  // Fallback: Wenn solution ein Array ist, gib es als Satz mit Leerzeichen zurück
  if (Array.isArray(question.solution)) {
    return question.solution.join(' ');
  }
  return String(question.solution);
}

/**
 * Get dialog quiz display information for a specific quiz
 */
export function getDialogQuizDisplay(question: IExerciseQuestionType, quizIndex: number): {
  question: string;
  choices: string[];
  correctAnswer: string;
  userAnswer?: string;
  isCorrect?: boolean;
} | null {
  if (question.type !== 'Dialog') {
    return null;
  }

  const dialogQuestion = question as any;
  const dialogData = dialogQuestion.dialogData;
  
  if (!dialogData || !dialogData.quizzes || !dialogData.quizzes[quizIndex]) {
    return null;
  }

  const quiz = dialogData.quizzes[quizIndex];
  const userAnswer = dialogQuestion.allQuizAnswers?.[quizIndex];
  const correctChoice = quiz.choices.find((choice: any) => choice.isCorrect);
  
  return {
    question: quiz.question,
    choices: quiz.choices.map((choice: any) => choice.text),
    correctAnswer: correctChoice?.text || '',
    userAnswer: userAnswer !== undefined ? quiz.choices[userAnswer]?.text : undefined,
    isCorrect: userAnswer !== undefined ? quiz.choices[userAnswer]?.isCorrect : undefined
  };
}

/**
 * Get all dialog quiz displays for a dialog exercise
 */
export function getAllDialogQuizDisplays(question: IExerciseQuestionType): Array<{
  question: string;
  choices: string[];
  correctAnswer: string;
  userAnswer?: string;
  isCorrect?: boolean;
}> {
  if (question.type !== 'Dialog') {
    return [];
  }

  const dialogQuestion = question as any;
  const dialogData = dialogQuestion.dialogData;
  
  if (!dialogData || !dialogData.quizzes) {
    return [];
  }

  return dialogData.quizzes.map((_: any, index: number) => 
    getDialogQuizDisplay(question, index)
  ).filter(display => display !== null) as Array<{
    question: string;
    choices: string[];
    correctAnswer: string;
    userAnswer?: string;
    isCorrect?: boolean;
  }>;
} 